	document.addEventListener('DOMContentLoaded', function () {
		const image = document.querySelector('#up-cx-ref-image-container picture img');
		const source = document.querySelector('#up-cx-ref-image-container picture source');
        
        const divRegForm = document.querySelector('#up-cx-ref-content-container');
 
		if (image) {
			image.src = 'https://cdn.uppromote.com/storage/uploads/customer-referral/landing-page/banner-horizontal/1744109375_3613966_5c53cb1368dd66060e8ea160f85de634.webp';
		}

		if (source) {
			source.srcset = 'https://cdn.uppromote.com/storage/uploads/customer-referral/landing-page/banner-horizontal/1744109375_3613966_5c53cb1368dd66060e8ea160f85de634.webp';
		}
      
        if (divRegForm) {
          divRegForm.style.paddingTop = "20px";
        }
	});